module.exports = __webpack_public_path__ + "static/total-99d61dbff26bafc16b901ce4d8e38b1a.svg";